import { Slider } from "@blueprintjs/core"
import { useEffect, useRef } from "react"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { PETestQuestionAnswer } from "src/modules/pe-tests-module/data/interfaces"
import { useTestsStore } from "src/modules/pe-tests-module/data/store"
import { IQuestProps } from "../Question"

let timeout : any = -1
const Range = ({ item, question, isLocked, isRight, choosedId, setIsRight, setChoosedId, setIsLocked }: IQuestProps ) : JSX.Element => {
    
    const getNominal = (val:number ): number => {
        return Math.abs(Math.round(val / 100 * question.range))
    }
    const setValue = ( val: number) => {
        const answer = val < 0 ? question.answers[0] : question.answers[1]
        setChoosedId( answer.id ) 

        setIsLocked( item.is_show_answer )
        const results = [...useTestsStore.getState().results]
        const coef = val > 0 ? 1 : -1
        const v = Math.abs( Math.round( val / (100 /question.range) ) * (100 /question.range) ) * coef
        //console.log(v) 
        drawTrack(v)
        value.set(v)
        results[ useTestsStore.getState().currentStep - 1 ] = { answer_id: answer.id, value: Math.abs(val) }
        useTestsStore.setState({ results })
    }
    
    const value = useSyncState<number>( 0 ) 

    const trackRef  = useRef(null)
    const ref1      = useRef(null)
    const ref2      = useRef(null)

    useEffect(() => { 
        (trackRef.current! as any).setAttribute("style",`width:0%; left:50%;`)
        value.set(0)
        return () => {
            if( value.get() === 0) {
                setValue(0)
            }
            clearTimeout( timeout )
        }
    }, [question])

    const drawTrack = (val:number) => { 
         const fill: string = val > 0 ? "#3587e9" : "#549c54";
         if(!!trackRef.current) {
            (trackRef.current! as any).setAttribute("style",`width:${ Math.abs(val / 2) }%; left:${ val > 0 ? 50 : 50 - Math.abs(val / 2) }%; background-color:${fill};]`)
            // console.log( ref2.current as any )
            // console.log( ref1.current as any )
            if(val > 0) {
                if(!!ref1.current)  (ref1.current as any)?.setAttribute("style",`opacity:${ 1 - Math.abs( val )/ 100 };`)
                if(!!ref2.current)  (ref2.current as any)?.setAttribute("style",`opacity:1;`)
            }
            else {
                if(!!ref2.current)  (ref2.current as any)?.setAttribute("style",`opacity:${ 1 - Math.abs( val )/ 100 };`)
                if(!!ref1.current)  (ref1.current as any)?.setAttribute("style",`opacity:1;`)
            }
         }
    }
 
    const onSlider = ( val: number ) => {
        drawTrack(val)
        value.set( val ) 
        // showToast({message: getNominal(val)})
    }
    const onRelease = ( val: number ) => {
        setValue( val )
        useTestsStore.setState({ currentStepValue: !!(getNominal(val)) ? val : null })
        if(item.is_timed) {
            timeout = setTimeout(() => {
                const next = useTestsStore.getState().currentStep + 1
                useTestsStore.setState({ 
                    currentStep: next
                })
            }, 800)
        } 
    }

    const _answers = question.answers?.map((answer: PETestQuestionAnswer, i: number) => {
        return <div className="w-100" key={answer.id}>
            <div className="p-md-4 p-2" ref={ i === 0 ? ref1 : ref2 }>
                {answer.title}
            </div>
        </div>
    }) 

    const labelRenderer = (value: number, opts?: any ) => {
        return getNominal(value).toString()
    }
    const labelStepSize = 100 / ( question.range || 10 )
    return question.id
        ?
        <div className="pe-matching-single flex-centered flex-column h-100" data-testid="test-question-range">
            <div className="pe-matching-content short-container" > 
                <div className="pe-matching-media">
                    <img src={question.thumbnail} className="pe-matching-image" alt="" />
                </div>
                <div className="pe-matching-title">
                    {question.title}
                </div>
                <div className="pe-matching-descr">
                    {question.post_content}
                </div>
                <div className={`w-100 d-flex flex-row ${ isLocked ? " untouchble opacity_75" : "" } `}>
                    {_answers}
                </div>
                <div className="w-100 my-5 pe-range-slider-cont px-4">
                    <div className="w-100 position-relative px-0">
                        <div className="bg-question-range">
                            <div className="pe-question-slider-track" ref={trackRef} />
                        </div>
                        <Slider
                            className="pe-question-range-slider"
                            min={ -100 }
                            max={ 100 }
                            labelStepSize={ labelStepSize }
                            value={ value.get() }
                            onChange={onSlider}
                            onRelease={onRelease}
                            showTrackFill={false}
                            labelRenderer={labelRenderer}
                            //labelStepSize={100} 
                        >                            
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
        :
        <CalloutNoExists /> 
} 
export default Range